// Angular
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  NgModule,
  provideExperimentalZonelessChangeDetection,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// NGRX
import { CaiServicesModule } from '@cai-services';
import { StoreModule } from '@ngrx/store';
// NGX Permissions
import {
  CaiCommonModule,
  CommonComponentsModule,
  CommonThemeModule,
  GlobalService,
  InactivityService,
  IntercomService,
  KtDialogService,
  LayoutConfig,
  LayoutConfigService,
  LayoutRefService,
  LayoutUtilsService,
  MenuAsideService,
  MenuConfigService,
  MenuHorizontalService,
  PageConfigService,
  RouterService,
  SplashScreenService,
  SubheaderService,
  environment,
  reducers,
} from '@cai-common';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AppInitService } from './app-init.service';
// Modules
import { AppRoutingModule } from './app-routing.module';
// Copmponents
import { AppComponent } from './app.component';
// Partials
import { AppProperties } from './app.properties';

export function initializeLayoutConfig(
  appConfig: LayoutConfigService,
  appLoadService: AppInitService,
) {
  // initialize app by loading default demo layout config
  return () => {
    if (appConfig.getConfig() === null) {
      appConfig.loadConfigs(new LayoutConfig().configs);
    }
    return appLoadService.init();
  };
}

@NgModule({
  declarations: [AppComponent],
  exports: [],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxPermissionsModule.forRoot(),
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    CaiCommonModule.forRoot(new AppProperties()),
    CaiServicesModule.forRoot(environment),
    CommonThemeModule,
    CommonComponentsModule,
  ],
  providers: [
    provideExperimentalZonelessChangeDetection(),
    InactivityService,
    LayoutConfigService,
    LayoutRefService,
    MenuConfigService,
    PageConfigService,
    KtDialogService,
    GlobalService,
    SplashScreenService,
    RouterService,
    AppInitService,
    provideAppInitializer(() => {
      const initializerFn = initializeLayoutConfig(
        inject(LayoutConfigService),
        inject(AppInitService),
      );
      return initializerFn();
    }),
    // template services
    SubheaderService,
    MenuHorizontalService,
    MenuAsideService,
    LayoutUtilsService,
    IntercomService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
